module.exports = __webpack_public_path__ + "static/media/postgresql.0a61cf7a.svg";